module.exports = __webpack_public_path__ + "img/SKLB-Evento.93efd983.png";